import axios from 'axios';
import swal from 'helpers/swal';
import history from '../components/history';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });
const apiElite = axios.create({ baseURL: process.env.REACT_APP_ELITE_API_HOST });

api.interceptors.request.use(config => {
    if (localStorage.token)
        config.headers.Authorization = `Bearer ${localStorage.token}`;

    return config;
});

api.interceptors.response.use(async ok=>{
  if(ok.data.status == 'false' && ok.data.message == 'user already logged in'){
    let a = await swal.user();
    if(a.isDismissed) {
      return {
        data:{
          message: "cancel",
          status: "false"
        }
      };
    } else if(a.isConfirmed){
      return await api.post('login',{...ok.data.credentials,to_force:true});
    }
  }
  return ok;
}, async error => {

    let isLogged = (
      localStorage.getItem("token") &&
      localStorage.getItem("username") &&
      localStorage.getItem("user") &&
      localStorage.getItem("profile") &&
      localStorage.getItem("img-user")
    );
    
    if(error.isAxiosError){
      localStorage.clear();
      if(window.location.href.indexOf('login')==-1 ){
        window.location.href = '\login';
      }
    }

    if(error.response.status === 500){
    }
    else if(error.response.status === 404){
    }
    else if (
      error.response.status === 401 || !isLogged
    ){
      if(error.response.status === 401){
        if(!localStorage.getItem("expired")){
          localStorage.setItem("expired",'1')
          await swal.session_expired();
          localStorage.clear();
          if(window.location.href.indexOf('login')==-1 ){
            window.location.href = '\login';
          }
        }
      } else {
        localStorage.clear();
        if(window.location.href.indexOf('login')==-1 ){
          window.location.href = '\login';
        }
      }
      // return history.push("login");
    }

    return Promise.reject(error);
});

export { api, apiElite };